import { AppyError } from '../../../../../Appy';
import { MissingLinkError } from '../../../../../LinkyLinky';
import ModalStore from '../../../../Modal/Store';
import { LearningCollectionSummaryResource } from '../../../Types';

export type LearningCollectionError = AppyError | MissingLinkError;

export interface Waiting {
  kind: 'waiting';
}

export interface Loading {
  kind: 'loading';
  learningCollectionSummaryResource: LearningCollectionSummaryResource;
}

export interface Ready {
  kind: 'ready';
  learningCollectionSummaryResource: LearningCollectionSummaryResource;
}

export interface Publishing {
  kind: 'publishing';
  learningCollectionSummaryResource: LearningCollectionSummaryResource;
}

export interface Hide {
  kind: 'hide';
  hideModalStore: ModalStore;
  learningCollectionSummaryResource: LearningCollectionSummaryResource;
}

export interface Error {
  kind: 'error';
  error: LearningCollectionError;
  learningCollectionSummaryResource: LearningCollectionSummaryResource;
}

export type LearningCollectionState = Waiting | Loading | Ready | Publishing | Hide | Error;

export const waiting = (): Waiting => ({
  kind: 'waiting',
});

export const loading = (
  learningCollectionSummaryResource: LearningCollectionSummaryResource,
): Loading => ({
  kind: 'loading',
  learningCollectionSummaryResource,
});

export const ready = (
  learningCollectionSummaryResource: LearningCollectionSummaryResource,
): Ready => ({
  kind: 'ready',
  learningCollectionSummaryResource,
});

export const publishing = (state: Ready): Publishing => ({
  kind: 'publishing',
  learningCollectionSummaryResource: state.learningCollectionSummaryResource,
});

export const hide = (state: Ready, hideModalStore: ModalStore): Hide => ({
  kind: 'hide',
  hideModalStore,
  learningCollectionSummaryResource: state.learningCollectionSummaryResource,
});

export const error = (error: LearningCollectionError, state: Ready | Publishing | Hide): Error => ({
  kind: 'error',
  learningCollectionSummaryResource: state.learningCollectionSummaryResource,
  error,
});
